<template>
  <v-flex xs6 sm5>
    <v-select
      v-model="status"
      :items="items"
      item-text="text"
      item-value="value"
      label="Status"
      persistent-hint
      return-object
      single-line
    ></v-select>
  </v-flex>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      items: [
        { text: "Todos", value: "" },
        { text: "Aguardando", value: "waiting" },
        { text: "Completo", value: "completed" },
        { text: "Cancelado", value: "cancelled" }
      ]
    };
  },
  computed: {
    ...mapGetters({
      storeStatus: "bills/filtersStatus"
    }),
    status: {
      get() {
        return this.storeStatus;
      },
      set(newStatus) {
        this.$store.dispatch("bills/setStatus", newStatus.value);
      }
    }
  }
};
</script>